// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BoardCard_wrapper__EewP_"};